import { createContext, useContext } from 'react'
import { type HubspotWorkflowsPageStore } from 'pages/hubspotWorkflows/store/HubspotWorkflowsPageStore'

export const HubspotWorkflowsPageContext = createContext<HubspotWorkflowsPageStore | null>(null)

export const useHubspotWorkflowsPageContext = () => {
  const context = useContext(HubspotWorkflowsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with HubspotWorkflowsPageContext'
    )

  return context
}
